import { useGoBackMutation } from '@twisto/api-graphql'

import { useSubmittingWrapper } from './submitting-wrapper.hook'

export const useGoBack = (sessionId: string) => {
  const [goBack] = useGoBackMutation()
  const submittingWrapper = useSubmittingWrapper()

  return async () =>
    submittingWrapper(
      goBack({
        variables: {
          auth: {
            sessionId,
          },
        },
      })
    )
}
